<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .uploads-modal {
    position: fixed;
    z-index: 2000;
    overflow: hidden;
    background-color: colors.get(interfaceWhite);
    animation: uploads-modal-appear 250ms ease-out;
    width: 400px;
    height: 675px;
    right: 20px;
    bottom: 88px;
    box-shadow: 0 5px 40px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
  }

  .uploads-modal-header {
    @include mixins.h3;
    padding: 24px 24px 0px 24px;
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .uploads-modal-body {
    padding: 16px;
    background: colors.get(interfaceWhite);
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  @keyframes uploads-modal-appear {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media print {
    .uploads-modal {
      display: none;
    }
  }
</style>

<script>
  import TabPanel from "@sourcewhale/shared/svelte-design-system/components/molecules/TabPanel.svelte";
  import { onMount } from "svelte";
  import RecentsTab from "./RecentsTab.svelte";
  import { activeTabStore, uploadsModalStore } from "./stores";
  import UploadsTab from "./UploadsTab.svelte";

  let modalElement = $state(null);

  const handleClickOutside = (event) => {
    const isLaunchButton = event.target.closest(
      "[uploads-widget-launch-button]"
    );
    const isInsideModal = event.target.closest("[uploads-widget-modal]");

    if ($uploadsModalStore && !isLaunchButton && !isInsideModal) {
      uploadsModalStore.set(false);
    }
  };

  onMount(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  const tabItems = [
    {
      label: "UPLOAD",
      slot: "uploads",
      snippet: uploadsSnippet,
    },
    {
      label: "RECENT",
      slot: "recents",
      snippet: recentsSnippet,
    },
  ];
</script>

{#snippet recentsSnippet()}
  <RecentsTab />
{/snippet}

{#snippet uploadsSnippet()}
  <UploadsTab />
{/snippet}

<div class="uploads-modal" bind:this={modalElement} uploads-widget-modal>
  <div class="uploads-modal-header">Resume Upload</div>
  <div class="uploads-modal-body">
    <TabPanel
      {tabItems}
      type="primary"
      bind:activeTab={$activeTabStore}
      tabPanelBodyStyle="padding: 0; gap: 16px;"
    />
  </div>
</div>
